/**
 * Converts ISO date string (yyyy-mm-dd) to display format (dd-mm-yyyy).
 * Returns '-' for null/empty values.
 */
export function formatDate(isoStr) {
  if (!isoStr) return '-';
  const parts = isoStr.split('-');
  if (parts.length !== 3) return isoStr;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

/**
 * Formats ISO datetime string to dd-mm-yyyy display.
 * Accepts full datetime like '2024-03-15T10:30:00Z'.
 */
export function formatDateTime(isoStr) {
  if (!isoStr) return '-';
  return formatDate(isoStr.slice(0, 10));
}
